import { render, staticRenderFns } from "./payments-finance-36.vue?vue&type=template&id=21427b90&viewBox=0%200%2024%2024"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports